import type { EnergyTypes } from '~/types/new/energy';

export const useZoneRepository = () => {
  const { client } = useApiV2();
  const { cancelRequestIfDoubled } = useCoreApiHelper();
  const { setZoneResponse, setZoneError, setLoading } = zoneStore();

  const getZone = async (options: { energy_type: EnergyTypes; start: string; end: string; max_depth: number; area_id: number }) => {
    const response = await cancelRequestIfDoubled({
      requestId: 'explore-zone',
      execute: async (signal) =>
        client.GET('/v2/areas/{area_id}/explore/subareas', {
          params: {
            query: {
              energy_type: options.energy_type,
              start: options.start,
              end: options.end,
              max_depth: options.max_depth,
            },
            path: {
              area_id: options.area_id,
            },
          },
          signal: signal,
        }),
      onLoadingStart: () => {
        setLoading(true);
      },
      onLoadingEnd: () => {
        setLoading(false);
      },
    });
    if (response.data) {
      setZoneResponse(response.data);
    }
    if (response.error) {
      setZoneError(response.error);
    }

    return response;
  };

  return { getZone };
};
